/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_ConfirmInputs */

const en_dialog_delete_confirm = /** @type {(inputs: Dialog_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete your account? This action cannot be undone.`)
};

const es_dialog_delete_confirm = /** @type {(inputs: Dialog_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete your account? This action cannot be undone." |
*
* @param {Dialog_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_confirm = /** @type {((inputs?: Dialog_Delete_ConfirmInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_ConfirmInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_confirm(inputs)
	return en_dialog_delete_confirm(inputs)
});